import { createFileRoute } from '@tanstack/react-router';

import { createQueryLoader } from '@/loader';
import StartSubmissionReportPageQueryNode, {
  type StartSubmissionReportPageQuery,
} from '@/pages/start/__generated__/StartSubmissionReportPageQuery.graphql';
import StartSubmissionReportPage from '@/pages/start/StartSubmissionReportPage';

const loadReport = createQueryLoader<StartSubmissionReportPageQuery>(
  StartSubmissionReportPageQueryNode,
);

export const Route = createFileRoute(
  '/_authenticated/start/$submissionId/report',
)({
  loader: ({ context, params }) =>
    loadReport({
      environment: context.relayEnvironment,
      variables: { submissionId: params.submissionId },
    }),
  component: StartSubmissionReportPage,
  shouldReload: false,
});
